import React, { Component } from "react"
import './index.css'

const HeatMapLegend = ({ rates, bgcColour, vehicleClass }) => (
  <div className="legend-container">
    <div className="heat-legend">
      {rates.map(rate => {
        return (
          <div className="legend-item">
            <div className="heat-block" style={{backgroundColor: bgcColour(rate, vehicleClass)}}></div>
            <p className="legend-label">{rate}</p>
          </div>
        )
      })}
    </div>
  </div>
)

export default HeatMapLegend;


// WEBPACK FOOTER //
// ./src/components/PriceMap/HeatMapLegend.js